import { render, staticRenderFns } from "./default.layout.vue?vue&type=template&id=f4565d06&"
import script from "./default.layout.vue?vue&type=script&lang=ts&"
export * from "./default.layout.vue?vue&type=script&lang=ts&"
import style0 from "./default.layout.vue?vue&type=style&index=0&id=f4565d06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports